export const ALERT_TEXT_DATA = {
  review: 'Некоторые отзывы удалены. Авторы сообщили, что написали их по заказу. Доверяйте остальным отзывам на этой странице с осторожностью.',
  rating: 'Рейтинг аннулирован: авторы отзывов сообщили, что писали отзывы по заказу',
}
